import OuraIcon from "@/assets/oura.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const OuraLogo = (props: Props) => (
  <LogoImage imgSrc={OuraIcon} alt="Oura Workspace Logo" size="navbar" {...props} />
);
